export default __webpack_public_path__ + "static/media/04436dd4a9513137a5100f498fcf027d1581616953588.3c8ff8fd.webp";